class Product extends HTMLElement {
  constructor() {
    super();

    this.productForm();
    this.productImages();
    this.productThumbnails();
    this.productImagesCounter();
    this.productTabs();
    this.productSizeGuide();
    this.betterPairedProductsCarousel();
    if (window.innerWidth > 991) {
      this.productCustomCursor();
    }
    this.productStickyAddToCart();
    this.stickySizesToggle();
  }

  stickySizesToggle() {
    const toggle = this.querySelector('.js-sticky-sizes-toggle');
    const list = this.querySelector('.js-sticky-sizes-list');
    if (!toggle || !list) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      list.classList.toggle('d-none');
    });

    list.querySelectorAll('.js-product-size').forEach(sizeElement => {
      sizeElement.addEventListener('click', () => {
        setTimeout(() => list.classList.add('d-none'), 200);
      });
    });
  }

  productForm() {
    const variants = (productId, sectionId) => {
      const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

      const selectCallback = (variant) => {
        const that = this.querySelector(`.js-product[data-product-id='${productId}']`);

        if (variant) {
          const priceOldElements = that.querySelectorAll(".js-price-old");
          const priceNewElements = that.querySelectorAll(".js-price-new");
          const priceDefaultElements = that.querySelectorAll(".js-price-default");
          if (variant.compare_at_price > variant.price) {
            priceOldElements.forEach(el => {
              el.classList.remove("d-none");
              el.innerHTML = Shopify.formatMoney(variant.compare_at_price);
            });
            priceNewElements.forEach(el => {
              el.classList.remove("d-none");
              el.innerHTML = Shopify.formatMoney(variant.price);
            });
            priceDefaultElements.forEach(el => {
              el.classList.add("d-none");
            });
          } else {
            priceOldElements.forEach(el => el.classList.add("d-none"));
            priceNewElements.forEach(el => el.classList.add("d-none"));
            priceDefaultElements.forEach(el => {
              el.classList.remove("d-none");
              el.innerHTML = Shopify.formatMoney(variant.price);
            });
          }

          const soldOutWrappers = that.querySelectorAll('.js-wrap-sold-out');
          const addToCartWrappers = that.querySelectorAll('.js-wrap-add-to-cart');

          const inStockEl = that.querySelector('.js-product-in-stock');
          const outOfStockEl = that.querySelector('.js-product-out-of-stock');
          const madeToOrderEl = that.querySelector('.js-product-made-to-order');

          if (!variant.available) {
            soldOutWrappers.forEach(wrapper => {
              wrapper.classList.remove('d-none');
              
              if (wrapper.firstElementChild) {
                wrapper.firstElementChild.style.display = '';
              }
            });

            addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));

            if (inStockEl) inStockEl.classList.add('d-none');
            if (madeToOrderEl) madeToOrderEl.classList.add('d-none');
            if (outOfStockEl) outOfStockEl.classList.remove('d-none');
          } else {
            soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));

            // "Ready to ship" requires BOTH: the product sits in the "Ready to Ship"
            // collection (flag set in Liquid), AND this particular size still has a
            // piece on the shelf. Anything else reads "Made to order".
            const inReadyCollection = that.getAttribute('data-ready-to-ship') === 'true';
            const statusOption = that.querySelector(`select[name='id'] option[value='${variant.id}']`);
            const statusQty = parseInt(statusOption?.getAttribute('data-quantity'), 10);
            const statusManaged = statusOption?.getAttribute('data-managed') === 'true';
            const sizeHasStock = !statusOption || !statusManaged || (!isNaN(statusQty) && statusQty > 0);
            const readyToShip = inReadyCollection && sizeHasStock;

            if (inStockEl) inStockEl.classList.toggle('d-none', !readyToShip);
            if (madeToOrderEl) madeToOrderEl.classList.toggle('d-none', readyToShip);
            if (outOfStockEl) outOfStockEl.classList.add('d-none');
          }

          that.querySelectorAll('.js-product-size').forEach(sizeElement => {
            let soldOut = true;
            const value = sizeElement.getAttribute('data-value');
            const option = sizeElement.getAttribute('data-option');

            const selectedOptions = {};
            that.querySelectorAll(`.selector-wrapper select`).forEach(select => {
              const optionName = select.getAttribute('data-option');
              if(optionName != option) {
                selectedOptions[optionName] = select.value;
              }
            });

            that.querySelectorAll(`select[name='id'] option`).forEach(option => {
              const option1 = option.getAttribute('data-option-1');
              const option2 = option.getAttribute('data-option-2');
              const option3 = option.getAttribute('data-option-3');

              const matchesSelectedOptions =
                  (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                  (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                  (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

              if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                if (!option.hasAttribute('disabled')) {
                  soldOut = false;
                }
              }
            });

            if (soldOut) {
              sizeElement.classList.add('out-of-stock');
            } else {
              sizeElement.classList.remove('out-of-stock');
            }
          });

          const selectedOption = that.querySelector("select[name='id'] option:checked");
          const selectedOptionQuantity = that.querySelector('.js-last-new-remaining-quantity');
          const quantity = parseInt(selectedOption?.getAttribute('data-quantity'), 10);

          if (selectedOptionQuantity && !isNaN(quantity)) {
            selectedOptionQuantity.innerHTML = quantity;
          }

          const lastFew = that.querySelector('.js-last-few-remaining');
          const lastFewOutOfStock = that.querySelector('.js-last-few-remaining-out-of-stock');

          if (isNaN(quantity) || quantity < 4) {
            if(quantity > 0) {
              lastFew?.classList.remove('d-none');
              lastFewOutOfStock?.classList.add('d-none');
            } else {
              lastFew?.classList.add('d-none');
              lastFewOutOfStock?.classList.remove('d-none');
            }
          } else {
            lastFew?.classList.add('d-none');
            lastFewOutOfStock?.classList.add('d-none');
          }

          if(selectedOption) {
            var addToCartBtn = this.querySelector(".js-add-to-cart");
            var preOrderText = addToCartBtn.getAttribute("data-preorder-text");
            var originalText = addToCartBtn.getAttribute("data-original-text");
            var preOrderInfo = this.querySelector(".js-product-pre-order-text");

            var continueSelling = selectedOption.getAttribute("data-continue-selling-when-out-of-stock") === "true";

            if(addToCartBtn) {
              if (continueSelling && quantity < 1 && preOrderInfo) {
                addToCartBtn.textContent = preOrderText;

                soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
                addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));

                if(preOrderInfo) {
                  preOrderInfo.classList.remove("d-none");
                }
              } else {
                addToCartBtn.textContent = originalText;

                if(preOrderInfo) {
                  preOrderInfo.classList.add("d-none");
                }
              }
            }
          }
        } else {
          const soldOutWrappers = that.querySelectorAll('.js-wrap-sold-out');
          const addToCartWrappers = that.querySelectorAll('.js-wrap-add-to-cart');

          const inStockEl = that.querySelector('.js-product-in-stock');
          const outOfStockEl = that.querySelector('.js-product-out-of-stock');
          const madeToOrderEl = that.querySelector('.js-product-made-to-order');

          soldOutWrappers.forEach(wrapper => {
            wrapper.classList.remove('d-none');
            
            if (wrapper.firstElementChild) {
              wrapper.firstElementChild.style.display = '';
            }
          });
            
          addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));

          if (inStockEl) inStockEl.classList.add('d-none');
          if (madeToOrderEl) madeToOrderEl.classList.add('d-none');
          if (outOfStockEl) outOfStockEl.classList.remove('d-none');
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }
    };

    document.querySelectorAll(".js-product:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll('.js-product-size').forEach(sizeElement => {
          sizeElement.addEventListener('click', function (event) {
            event.preventDefault();

            const value = this.getAttribute('data-value');
            const option = this.closest('ul').getAttribute('data-option');

            const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));

              const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`);
              if (optionValues.length) {
                optionValues.forEach(optionValue => {
                  optionValue.classList.remove('active');

                  if (optionValue.getAttribute('data-value') === value) {
                    optionValue.classList.add('active');
                  }
                });
              }
            }
          });
        });
      }

      element.classList.add("active");
    });
  }

  productImages() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.js-pswp-gallery',
      children: 'a[data-pswp-width][data-pswp-height]',
      pswpModule: PhotoSwipe
    });
    lightbox.init();

    const carousel = this.querySelector('.js-product-images-mobile-carousel');
    if (!carousel) return;

    const isMobile = () => window.innerWidth < 992;

    const ensureScrollbar = () => {
      let wrap = this.querySelector('.js-mobile-carousel-scrollbar');
      if (wrap) {
        const track = wrap.querySelector('.js-mobile-carousel-scrollbar-track');
        const bar = wrap.querySelector('.js-mobile-carousel-scrollbar-bar');
        if (track && bar) return { wrap, track, bar };
      }

      wrap = document.createElement('div');
      wrap.className = 'mobile-carousel-scrollbar js-mobile-carousel-scrollbar';

      const track = document.createElement('div');
      track.className = 'mobile-carousel-scrollbar__track js-mobile-carousel-scrollbar-track';

      const bar = document.createElement('div');
      bar.className = 'mobile-carousel-scrollbar__bar js-mobile-carousel-scrollbar-bar';

      track.appendChild(bar);
      wrap.appendChild(track);

      carousel.insertAdjacentElement('afterend', wrap);

      bar.style.width = '0%';

      return { wrap, track, bar };
    };

    const { wrap, bar } = ensureScrollbar();

    const setScrollbar = () => {
      const max = carousel.scrollWidth - carousel.clientWidth;
      const progress = max > 0 ? (carousel.scrollLeft / max) : 0;
      const pct = Math.max(0, Math.min(100, progress * 100));

      bar.style.width = `${pct}%`;
      bar.setAttribute('aria-valuenow', String(Math.round(pct)));
    };

    let cleanup = () => {};

    const bind = () => {
      cleanup();

      if (!isMobile()) {
        wrap.classList.add('d-none');
        cleanup = () => {};
        return;
      }

      wrap.classList.remove('d-none');

      const onScroll = () => setScrollbar();
      const onResize = () => setScrollbar();

      carousel.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      setScrollbar();

      cleanup = () => {
        carousel.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
      };
    };

    bind();
    window.addEventListener('resize', bind, { passive: true });
  }

  productThumbnails() {
    const thumbnails = this.querySelector('.js-product-thumbnails');
    const imagesWrap = this.querySelector('.js-product-images');
    if (!thumbnails || !imagesWrap) return;

    const rafThrottle = (fn) => {
      let rafId = null;
      return (...args) => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          fn(...args);
        });
      };
    };

    const setHeight = () => {
      const h = Math.round(imagesWrap.getBoundingClientRect().height);
      if (h > 0) thumbnails.style.height = `${h}px`;
    };
    const update = rafThrottle(setHeight);
    setHeight();
    requestAnimationFrame(setHeight);
    window.addEventListener('resize', update, { passive: true });

    const getItems = () => [...imagesWrap.querySelectorAll('.js-product-media')];
    const getThumbs = () => [...thumbnails.querySelectorAll('.js-scroll-to-product-media')];

    const setCounterImmediate = (mediaIndex1) => {
      const counter = this.querySelector('.js-product-images-current-counter');
      if (counter) counter.textContent = String(mediaIndex1);
    };

    const setActiveThumbByIndex1 = (index1) => {
      const thumbs = getThumbs();
      if (!thumbs.length) return;

      const idx = Number(index1) || 1;
      thumbs.forEach(a => a.classList.remove('active'));

      const active = thumbs.find(a => Number(a.dataset.index) === idx);
      (active || thumbs[idx - 1])?.classList.add('active');
    };

    const lock = () => { this.dataset.thumbsScrolling = '1'; };
    const unlock = () => { delete this.dataset.thumbsScrolling; };

    const waitForScrollEnd = (el, { idleMs = 140, maxMs = 1500 } = {}) => {
      return new Promise(resolve => {
        let idleTimer = null;
        let maxTimer = null;

        const done = () => {
          el.removeEventListener('scroll', onScroll);
          clearTimeout(idleTimer);
          clearTimeout(maxTimer);
          resolve();
        };

        const onScroll = () => {
          clearTimeout(idleTimer);
          idleTimer = setTimeout(done, idleMs);
        };

        el.addEventListener('scroll', onScroll, { passive: true });
        idleTimer = setTimeout(done, idleMs);
        maxTimer = setTimeout(done, maxMs);
      });
    };

    const scrollToIndex1 = async (index1) => {
      const items = getItems();
      if (!items.length) return;

      items.forEach((el, i) => (el.dataset.index = String(i + 1)));

      const idx = Math.max(1, Math.min(items.length, Number(index1) || 1));

      const target =
        items.find(el => Number(el.dataset.index) === idx) || items[idx - 1];
      if (!target) return;

      setActiveThumbByIndex1(idx);
      setCounterImmediate(idx);

      lock();

      const isMobile = () => window.innerWidth < 992;

      if (isMobile()) {
        const scroller =
          this.querySelector('.js-product-images-mobile-carousel') || imagesWrap;

        const left = target.offsetLeft - (scroller.clientWidth / 2) + (target.clientWidth / 2);
        scroller.scrollTo({ left, behavior: 'smooth' });

        await waitForScrollEnd(scroller, { idleMs: 140, maxMs: 1500 });
        unlock();
      } else {
        const header = document.querySelector('.js-header, .header, .site-header');
        const topOffset = header ? Math.round(header.getBoundingClientRect().height) : 0;

        const y = window.scrollY + target.getBoundingClientRect().top - topOffset - 8;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });

        let lastY = window.scrollY;
        let same = 0;

        const tick = () => {
          const now = window.scrollY;
          if (Math.abs(now - lastY) < 1) same += 1;
          else same = 0;
          lastY = now;

          if (same > 10) {
            unlock();
            return;
          }
          requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
      }
    };

    const onThumbClick = (e) => {
      const a = e.target.closest('.js-scroll-to-product-media');
      if (!a || !thumbnails.contains(a)) return;

      e.preventDefault();

      const idx = a.dataset.index;
      if (idx == null) return;

      scrollToIndex1(Number(idx));
    };

    thumbnails.addEventListener('click', onThumbClick);
  }

  productImagesCounter() {
    const currentEl = this.querySelector('.js-product-images-current-counter');
    const imagesWrap = this.querySelector('.js-product-images');
    if (!currentEl || !imagesWrap) return;

    const items = [...imagesWrap.querySelectorAll('.js-product-media')];
    if (!items.length) return;

    const thumbs = [...this.querySelectorAll('.js-scroll-to-product-media')];

    items.forEach((el, i) => (el.dataset.index = String(i + 1)));

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const rafThrottle = (fn) => {
      let rafId = 0;
      return (...args) => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          fn(...args);
        });
      };
    };

    const isLocked = () => this.dataset.thumbsScrolling === '1';

    const setActiveThumb = (mediaIndex1) => {
      if (!thumbs.length) return;
      const idx = clamp(Number(mediaIndex1) || 1, 1, thumbs.length);

      thumbs.forEach(a => a.classList.remove('active'));
      const active = thumbs.find(a => Number(a.dataset.index) === idx);
      (active || thumbs[idx - 1])?.classList.add('active');
    };

    const set = (mediaIndex1) => {
      const idx = clamp(Number(mediaIndex1) || 1, 1, items.length);
      currentEl.textContent = String(idx);
      setActiveThumb(idx);
    };

    const isMobile = () => window.innerWidth < 992;

    let cleanup = () => {};

    const bindMobile = () => {
      const scroller =
        this.querySelector('.js-product-images-mobile-carousel') || imagesWrap;

      const getBestIndex = () => {
        const center = scroller.scrollLeft + scroller.clientWidth / 2;

        let best = 1;
        let bestDist = Infinity;

        items.forEach((el, i) => {
          const elCenter = el.offsetLeft + el.offsetWidth / 2;
          const d = Math.abs(elCenter - center);
          if (d < bestDist) {
            bestDist = d;
            best = i + 1;
          }
        });

        return best;
      };

      const onScroll = rafThrottle(() => {
        if (isLocked()) return;
        set(getBestIndex());
      });

      scroller.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      return () => scroller.removeEventListener('scroll', onScroll);
    };

    const bindDesktop = () => {
      const getTopOffset = () => {
        const header = document.querySelector('.js-header, .header, .site-header');
        return header ? Math.round(header.getBoundingClientRect().height) : 0;
      };

      const getBestIndex = () => {
        const topOffset = getTopOffset();
        const anchorY = topOffset + 16;
        const viewTop = topOffset;
        const viewBottom = window.innerHeight;

        for (let i = 0; i < items.length; i++) {
          const r = items[i].getBoundingClientRect();
          if (r.top <= anchorY && r.bottom > anchorY) return i + 1;
        }

        let best = 1;
        let bestVisible = -1;
        let bestTie = Infinity;

        items.forEach((el, i) => {
          const r = el.getBoundingClientRect();
          const visible = Math.max(
            0,
            Math.min(r.bottom, viewBottom) - Math.max(r.top, viewTop)
          );

          if (visible > bestVisible) {
            bestVisible = visible;
            best = i + 1;
            bestTie = Math.abs(r.top - viewTop);
          } else if (visible === bestVisible) {
            const tie = Math.abs(r.top - viewTop);
            if (tie < bestTie) {
              bestTie = tie;
              best = i + 1;
            }
          }
        });

        return best;
      };

      const onScroll = rafThrottle(() => {
        if (isLocked()) return;
        set(getBestIndex());
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      set(1);
      onScroll();

      return () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      };
    };

    const apply = () => {
      cleanup();
      cleanup = isMobile() ? bindMobile() : bindDesktop();
    };

    apply();
    window.addEventListener('resize', rafThrottle(apply), { passive: true });
  }

  productTabs() {
    const root = this || document;
    const tabsWrap = root.querySelector('.product__tabs');
    if (!tabsWrap) return;

    const navLinks = tabsWrap.querySelectorAll('.js-toggle-product-tab');
    const tabs = tabsWrap.querySelectorAll('.js-product-tab');

    if (!navLinks.length || !tabs.length) return;

    let rafId = null;

    const activateTab = (index) => {
      navLinks.forEach(link => {
        link.classList.toggle('active', link.dataset.index === index);
      });

      tabs.forEach(tab => {
        const isActive = tab.dataset.index === index;

        if (isActive) {
          tab.classList.add('display');

          clearTimeout(tab._showTimeout);
          tab._showTimeout = setTimeout(() => {
            tab.classList.add('show');
          }, 10);
        } else {
          tab.classList.remove('show');
          tab.classList.remove('display');
        }
      });
    };

    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const index = link.dataset.index;
        if (!index) return;
        activateTab(index);
      });
    });
  }

  productSizeGuide() {
    const table = document.querySelector('.js-size-table');
    const switches = [...document.querySelectorAll('.js-toggle-size-guide-table-switcher')];
    if (!table || !switches.length) return;

    const scrollbarWrap = document.querySelector('.js-table-progess-scrollbar');
    const scrollbarBar = scrollbarWrap ? (scrollbarWrap.querySelector('p') || scrollbarWrap) : null;

    function getScrollEl() {
      if (!table) return null;
      if (table.scrollWidth > table.clientWidth) return table;
      const parent = table.parentElement;
      if (parent && parent.scrollWidth > parent.clientWidth) return parent;
      return table;
    }

    function updateScrollbar() {
      if (!scrollbarBar) return;

      const sc = getScrollEl();
      if (!sc) return;

      const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
      const hasScroll = max > 0;

      if (!hasScroll) {
        if (scrollbarWrap) scrollbarWrap.classList.add('is-hidden');
        scrollbarBar.style.width = '100%';
        return;
      }

      if (scrollbarWrap) scrollbarWrap.classList.remove('is-hidden');

      const p = Math.min(1, Math.max(0, sc.scrollLeft / max));
      scrollbarBar.style.width = `${p * 100}%`;
    }

    const scrollEl = getScrollEl();
    if (scrollEl) scrollEl.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar);

    const ths = [...table.querySelectorAll('thead th')];
    const measureColIdxs = ths
      .map((th, i) => ({ i, t: th.textContent }))
      .filter(x => /\((cm|in)\)/i.test(x.t))
      .map(x => x.i);

    const measureCells = [...table.querySelectorAll('tbody tr')].flatMap(tr =>
      measureColIdxs.map(i => tr.children[i]).filter(Boolean)
    );

    const originalCmText = new Map();

    function parseRange(text) {
      const t = text
        .trim()
        .replace(/,/g, '.')
        .replace(/\s*(cm|in|inch|inches|\")\s*$/i, '')
        .trim();

      const mRange = t.match(/^(\d+(?:\.\d+)?)\s*(?:–|—|-)\s*(\d+(?:\.\d+)?)$/);
      if (mRange) return { a: parseFloat(mRange[1]), b: parseFloat(mRange[2]) };

      const mOne = t.match(/^(\d+(?:\.\d+)?)$/);
      if (mOne) return { a: parseFloat(mOne[1]), b: null };

      return null;
    }

    function fmt(n) {
      return (Math.round(n * 100) / 100).toString();
    }

    function setHeaderUnit(toUnit) {
      const ths2 = [...table.querySelectorAll('thead th')];
      measureColIdxs.forEach(i => {
        const th = ths2[i];
        if (!th) return;
        th.textContent = th.textContent.replace(/\((cm|in)\)/ig, `(${toUnit})`);
      });
    }

    function setActiveSwitch(unit) {
      switches.forEach(btn => {
        const u = (btn.dataset.sizeGuide || '').toLowerCase();
        const isActive = (unit === 'cm' && u === 'cm') || (unit === 'in' && u === 'inches');
        btn.classList.toggle('active', isActive);
      });
    }

    function toInches() {
      setHeaderUnit('in');
      setActiveSwitch('in');

      measureCells.forEach(cell => {
        const txt = cell.textContent.trim();
        if (!originalCmText.has(cell)) originalCmText.set(cell, txt);

        const base = originalCmText.get(cell) || txt;
        const r = parseRange(base);
        if (!r) return;

        const aIn = r.a / 2.54;
        if (r.b == null) {
          cell.textContent = `${fmt(aIn)}`;
        } else {
          const bIn = r.b / 2.54;
          cell.textContent = `${fmt(aIn)}–${fmt(bIn)}`;
        }
      });

      updateScrollbar();
    }

    function toCm() {
      setHeaderUnit('cm');
      setActiveSwitch('cm');

      measureCells.forEach(cell => {
        const orig = originalCmText.get(cell);
        if (orig != null) cell.textContent = orig;
      });

      updateScrollbar();
    }

    measureCells.forEach(cell => originalCmText.set(cell, cell.textContent.trim()));

    switches.forEach(btn => {
      btn.addEventListener('click', () => {
        const unit = (btn.dataset.sizeGuide || '').toLowerCase();
        if (unit === 'inches') toInches();
        else if (unit === 'cm') toCm();
      });
    });

    const active = switches.find(b => b.classList.contains('active'));
    if (active && (active.dataset.sizeGuide || '').toLowerCase() === 'inches') toInches();
    else toCm();

    document.querySelectorAll('.js-open-size-guide').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const guide = document.querySelector('.js-size-guide');
        if (!guide) return;

        guide.classList.add('display');

        if (window.lenis) window.lenis.stop();
        else document.body.style.overflow = "hidden";

        setTimeout(() => {
          guide.classList.add('active');
          requestAnimationFrame(updateScrollbar);
          setTimeout(updateScrollbar, 150);
        }, 50);
      });
    });

    document.querySelectorAll('.js-close-size-guide').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const guide = document.querySelector('.js-size-guide');
        if (!guide) return;

        guide.classList.add('closing');

        if (window.lenis) window.lenis.start();
        else document.body.style.overflow = "visible";

        setTimeout(() => {
          guide.classList.remove('display', 'active', 'closing');
        }, 300);
      });
    });

    updateScrollbar();
  }

  betterPairedProductsCarousel() {
    const carousels = this.querySelectorAll('.js-paired-products-carousel');
    if (!carousels.length) return;

    const arrowSVG = `
      <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.486695 5.68448C2.63601 7.28763 4.93885 8.74164 7.35683 9.97196C7.51035 10.0465 7.85578 10.1584 7.97092 9.97196C8.08606 9.74827 7.77902 9.41272 7.66388 9.30088C6.4357 8.10784 5.16913 6.98937 3.86419 5.90818L3.09658 5.27437L3.71067 4.56601L8.93043 1.24787C9.31424 1.02418 8.0093 -0.280705 7.47198 0.0548363C5.01561 1.6207 2.55925 3.18656 0.0645123 4.7897C-0.204152 4.97612 0.448317 5.60992 0.525078 5.68448H0.486695ZM2.13706 5.57263C2.82791 6.09459 3.51877 6.65382 4.17124 7.21306C3.40363 6.72839 2.63602 6.24372 1.90678 5.72176C1.98354 5.68448 2.0603 5.6472 2.13706 5.57263Z" fill="currentColor"/>
      </svg>
    `;

    carousels.forEach((element, index) => {
      if (element.__splideInstance) return;

      const uniqueClass = `js-paired-products-carousel-${String(index + 1).padStart(2, '0')}`;
      element.classList.add(uniqueClass);

      const arrows = document.createElement('div');
      arrows.className = 'splide__arrows paired-products__arrows';

      arrows.innerHTML = `
        <button class="splide__arrow splide__arrow--prev paired-products__arrow paired-products__arrow--prev" type="button">
          ${arrowSVG}
        </button>
        <button class="splide__arrow splide__arrow--next paired-products__arrow paired-products__arrow--next" type="button">
          ${arrowSVG}
        </button>
      `;

      element.appendChild(arrows);

      const splide = new Splide(element, {
        type: 'slide',
        drag: 'free',
        gap: '8px',
        perPage: 3,
        rewind: false,
        arrows: true,
        pagination: false,
        breakpoints: {
          767: { perPage: 3, gap: '8px' },
          991: { perPage: 3, gap: '8px' },
          1198: { perPage: 2, gap: '8px' },
          1440: { perPage: 3, gap: '8px' }
        }
      });

      splide.mount();
      element.__splideInstance = splide;
    });
  }

  productCustomCursor() {
    const cursor = document.querySelector('.js-product-media-custom-cursor');

    if (!cursor) return;

    document.addEventListener('mousemove', (e) => {
      cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
    });

    let hoverCount = 0;

    document.querySelectorAll('.js-product-media, .js-open-product-zoom').forEach(media => {
      media.addEventListener('mouseenter', () => {
        hoverCount++;
        cursor.classList.add('active');
      });

      media.addEventListener('mouseleave', () => {
        hoverCount = Math.max(0, hoverCount - 1);
        if (hoverCount === 0) {
          cursor.classList.remove('active');
        }
      });
    });
  }

  productStickyAddToCart() {
    const sticky = this.querySelector('.js-product-sticky-add-to-cart');
    if (!sticky) return;

    const wrap = this.querySelector('.js-product-form-button');
    if (!wrap) return;

    const footer = document.querySelector('footer, .footer, .site-footer, .js-footer');

    const isWrapAboveViewport = () => {
      const r = wrap.getBoundingClientRect();
      return r.bottom <= 0;
    };

    const isWrapBelowStickyOnScreen = () => {
      const w = wrap.getBoundingClientRect();
      const s = sticky.getBoundingClientRect();
      return w.top >= s.bottom;
    };

    const farFromFooterEnd = () => {
      if (!footer) return true;
      const f = footer.getBoundingClientRect();
      return (f.bottom - window.innerHeight) > 250; 
    };

    let raf = 0;
    const requestUpdate = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;

        const shouldBeActive =
          isWrapAboveViewport() &&   
          farFromFooterEnd() &&  
          !isWrapBelowStickyOnScreen();

        sticky.classList.toggle('active', shouldBeActive);
      });
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    requestUpdate();
  }
}

if(document.querySelector("product-page")) {
  customElements.define("product-page", Product);
}